import { render, staticRenderFns } from "./Intent.vue?vue&type=template&id=13fc7cc0&"
import script from "./Intent.vue?vue&type=script&lang=js&"
export * from "./Intent.vue?vue&type=script&lang=js&"
import style0 from "./Intent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports